import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Header from "../../../common/Header";
import SearchOffRoundedIcon from "@mui/icons-material/SearchOffRounded";

function NotFound() {
  const history = useNavigate();
  return (
    <>
      <Header />
      <Container className="mt-4 mx-auto">
        <Row>
          <Col>
            <div className="pt-4 mt-4 d-flex flex-column vertical-center justify-content-center">
              <SearchOffRoundedIcon className="largeicon text-muted" />
              <p className="text-center fs-4 pb-4">
                Sorry, I can't find what you are looking for
              </p>
              <button
                className="btn btn-md bg-danger text-white"
                size="lg"
                onClick={() => history("/")}>
                Back to Home
              </button>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default NotFound;
